import { createContext, useContext, useState, useEffect } from 'react'
import { applyTheme } from './theme'

// Apply theme synchronously before React renders to avoid flash
;(() => {
  try {
    const isDark = localStorage.getItem('ypf_theme') === 'dark'
    applyTheme(isDark)
  } catch {}
})()

const AppPrefsContext = createContext({ darkMode: false, lang: 'zh-TW' })

export const useAppPrefs = () => useContext(AppPrefsContext)

export function AppPrefsProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    try { return localStorage.getItem('ypf_theme') === 'dark' } catch { return false }
  })
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('ypf_lang') || 'zh-TW' } catch { return 'zh-TW' }
  })

  useEffect(() => {
    applyTheme(darkMode)
    try { localStorage.setItem('ypf_theme', darkMode ? 'dark' : 'light') } catch {}
  }, [darkMode])

  useEffect(() => {
    try { localStorage.setItem('ypf_lang', lang) } catch {}
  }, [lang])

  // Apply theme on first render (before any state change)
  useEffect(() => { applyTheme(darkMode) }, [])

  return (
    <AppPrefsContext.Provider value={{ darkMode, setDarkMode, lang, setLang }}>
      {children}
    </AppPrefsContext.Provider>
  )
}
